import { type ReactNode, createContext, useMemo, use } from 'react'
import { toCouponsById } from '@/features/shop/services/Coupons/utils'
import { type Coupon, type CouponsById } from '@/features/shop/services/Coupons/types'

const CouponsContext = createContext<CouponsById | null>(null)

type Props = { coupons: Coupon[]; children: ReactNode }

export const CouponsContextProvider = ({ children, coupons }: Props) => {
  const value = useMemo(() => toCouponsById(coupons), [coupons])
  return <CouponsContext value={value}>{children}</CouponsContext>
}

export const useCouponsContext = () => use(CouponsContext)
